import { FC, useMemo, useState } from 'react'
import styles from 'components/atoms/Arc/Arc.styl'
import cn from 'classnames'
import { ResizeHandler } from 'handlers/ResizeHandler/ResizeHandler'

type ArcProps = {
  ratio: number
  className?: string
}
export const Arc: FC<ArcProps> = (props) => {
  const { ratio, className } = props

  const [size, setSize] = useState<ClientRect | null>(null)

  const svgChild = useMemo(() => {
    if (!size) {
      return null
    }
    const { width, height } = size
    const sideSize = Math.min(width, height)
    const radius = sideSize / 2
    const circleLength = 2 * Math.PI * radius
    const strokeLength = circleLength - circleLength * ratio

    return (
      <svg width={ sideSize } height={ sideSize }>
        <circle
          cx={ radius }
          cy={ radius }
          r={ radius }
          strokeDasharray={ circleLength }
          strokeDashoffset={ strokeLength }
          className={ styles.circle }
        />
      </svg>
    )
  }, [size, ratio])

  return (
    <ResizeHandler onChange={ setSize } className={ cn(styles.arc, className) }>
      { svgChild }
    </ResizeHandler>
  )
}
